// This allows us to load Angular components on legacy server-side pages.
import { Injector, NgModuleFactory, NgModuleFactoryLoader, OnInit, ViewContainerRef, } from '@angular/core';
import { components } from './components';
var CompatComponent = /** @class */ (function () {
    function CompatComponent(injector, 
    // tslint:disable-next-line:deprecation FIXME: T106089
    loader) {
        this.injector = injector;
        this.loader = loader;
        this.class = 'WebappCompatWrapper';
    }
    CompatComponent.prototype.ngOnInit = function () {
        var _this = this;
        components
            // Only bootstrap the components on the page
            .filter(function (_a) {
            var selector = _a.selector;
            return document.getElementsByTagName(selector)[0];
        })
            .forEach(function (_a) {
            var selector = _a.selector, loadChildren = _a.loadChildren, component = _a.component, path = _a.path;
            return _this.loader
                .load(loadChildren)
                .then(function (ngModuleFactory) {
                // NgModuleFactory
                var componentFactory = ngModuleFactory
                    .create(_this.injector) // ngModuleRef
                    .componentFactoryResolver.resolveComponentFactory(component);
                if (path === 'hack_path_not_used_index_0') {
                    _this.entryPoint.createComponent(componentFactory, 0);
                }
                else {
                    _this.entryPoint.createComponent(componentFactory);
                }
            });
        });
    };
    return CompatComponent;
}());
export { CompatComponent };
